import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { css } from '@emotion/react';
import { Link as RouterLink } from 'react-router-dom';
import { colors, fonts } from '../../styles/theme';
import { Icon } from '../../ui_elements/icons';
import { buttonStyles } from '../../form/buttons/button-variants';

const linkStyles = css`
  font-family: ${fonts.sans.family};
  font-weight: ${fonts.sans.weight.bold};
  color: ${colors.blue.primary};
  text-decoration: none;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const A = styled('a')(linkStyles);

A.defaultProps = {};

A.propTypes = {
  href: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export const Link = styled(RouterLink)(linkStyles);

const BlankA = styled(A)`
  ${Icon} {
    display: inline-block;
    font-size: ${fonts.sans.size.small};
    line-height: ${fonts.sans.size.small};
    position: relative;
    top: 1px;
  }
`;

export const ButtonLink = styled(A)((props) => buttonStyles(props));

export const BlankLink = (props) => {
  const { href, children, title } = props;

  return (
    <BlankA target="_blank" rel="noopener noreferrer" href={href} title={title}>
      {children}
      <Icon color={colors.blue.primary} type="external-link" withTextLeft />
    </BlankA>
  );
};

BlankLink.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  title: PropTypes.string.isRequired,
};
